// Global Variables
let isMoving = false;
let moveAttempts = 0;
const MAX_ATTEMPTS = 5;

// Moving Function
function moveCurrencySwitcher() {
  if (isMoving || moveAttempts >= MAX_ATTEMPTS) return;

  isMoving = true;
  moveAttempts++;

  const currencySwitcher = document.querySelector(".pick_currency.mldesk");
  if (!currencySwitcher) {
    isMoving = false;
    setTimeout(moveCurrencySwitcher, 500);
    return;
  }

  function moveToTarget() {
    const headerIcons = document.querySelector(".header__icons");
    const mobileTarget = document.querySelector(
      ".menu-drawer__localization.header-localization localization-form"
    );

    if (!headerIcons && !mobileTarget) {
      isMoving = false;
      return;
    }

    try {
      if (window.innerWidth < 990 && mobileTarget) {
        if (!mobileTarget.contains(currencySwitcher)) {
          mobileTarget.appendChild(currencySwitcher);
          currencySwitcher.classList.add("DRAWER");
        }
      } else if (headerIcons) {
        if (headerIcons.firstChild !== currencySwitcher) {
          headerIcons.insertBefore(currencySwitcher, headerIcons.firstChild);
          currencySwitcher.classList.remove("DRAWER");
        }
      }
    } catch (error) {
      console.error("Error moving currency switcher:", error);
    }

    isMoving = false;
  }

  requestAnimationFrame(moveToTarget);

  // Reset moveAttempts after 5 seconds
  setTimeout(() => {
    moveAttempts = 0;
  }, 5000);
}

function initializeMove() {
  moveAttempts = 0;

  setTimeout(() => {
    moveCurrencySwitcher();
    updateCurrencySwitcherClass();
    removeDefaultMobileCurrencySwitcher();

    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        moveAttempts = 0;
        moveCurrencySwitcher();
        updateCurrencySwitcherClass();
        removeDefaultMobileCurrencySwitcher();
      }, 250);
    });
  }, 1000);
}

// Mobile Function
function updateCurrencySwitcherClass() {
  const currencySwitcher = document.querySelector(".pick_currency.mldesk");
  if (!currencySwitcher) return;

  if (window.innerWidth < 990) {
    currencySwitcher.classList.add("DRAWER");
  } else {
    currencySwitcher.classList.remove("DRAWER");
  }
}

function removeDefaultMobileCurrencySwitcher() {
  const defaultMobileCurrencySwitcher = document.querySelector(
    ".menu-drawer__menu .pick_currency.mldcustom"
  );
  if (defaultMobileCurrencySwitcher) {
    defaultMobileCurrencySwitcher.remove();
  }
}

// Flag Element
function createFlagElement(currency, flagUrl) {
  const img = document.createElement("img");
  img.src = flagUrl;
  img.alt = `${currency} flag`;
  img.className = "currency-flag";
  return img;
}

function addFlagsToOptions() {
  const options = document.querySelectorAll(".pick_currency .list .option");
  options.forEach((option) => {
    if (option.querySelector("span.wrapper")) return;

    const currency = option.getAttribute("data-value");
    const flagUrl = getFlagUrl(currency);

    if (flagUrl) {
      const spanWrapper = document.createElement("span");
      spanWrapper.className = "wrapper";
      spanWrapper.style.display = "flex";
      spanWrapper.style.alignItems = "center";

      const img = createFlagElement(currency, flagUrl);
      spanWrapper.appendChild(img);
      spanWrapper.appendChild(document.createTextNode(currency));

      option.textContent = "";
      option.appendChild(spanWrapper);
    }
  });
}

function updateCurrentFlag(forceUpdate = false) {
  const currentSpan = document.querySelector(".mlcurrent");
  if (!currentSpan) {
    console.log("Elemen .mlcurrent belum tersedia.");
    return;
  }
  if (forceUpdate) {
    const existingFlag = currentSpan.querySelector(".currency-flag");
    if (existingFlag) existingFlag.remove();
  } else if (currentSpan.querySelector(".currency-flag")) {
    return;
  }

  const currency = currentSpan.textContent.trim();
  const flagUrl = getFlagUrl(currency);

  if (flagUrl && currency) {
    const text = currentSpan.textContent;
    currentSpan.textContent = "";

    const img = createFlagElement(currency, flagUrl);
    currentSpan.appendChild(img);
    currentSpan.appendChild(document.createTextNode(text));
  }
}

function getFlagUrl(currency) {
  const exceptions = {
    EUR: "eu",
    GBP: "gb",
    TRY: "tr",
  };

  const countryCode = exceptions[currency] || currency.substring(0, 2).toLowerCase();

  return countryCode ? `https://flagcdn.com/${countryCode}.svg` : "";
}


function initializeCurrencyFlags() {
  setTimeout(() => {
    updateCurrentFlag(true);
    addFlagsToOptions();
    updateCurrencySwitcherClass();
  }, 500);
}

// Observers and Event Listeners
function setupObservers() {
  const mlcurrent = document.querySelector(".mlcurrent");
  if (mlcurrent) {
    const currencyObserver = new MutationObserver(() => {
      setTimeout(() => updateCurrentFlag(true), 100);
    });

    currencyObserver.observe(mlcurrent, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "childList" &&
        Array.from(mutation.addedNodes).some((node) =>
          node.classList?.contains("pick_currency") ||
          node.classList?.contains("localization-wrapper") ||
          node.classList?.contains("menu-drawer__localization")
        )
      ) {
        moveAttempts = 0;
        moveCurrencySwitcher();
        updateCurrencySwitcherClass();
        removeDefaultMobileCurrencySwitcher();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function setupEventListeners() {
  const currencySwitcher = document.querySelector(".pick_currency.mldesk");
  if (currencySwitcher) {
    currencySwitcher.addEventListener("click", () => {
      addFlagsToOptions();
      setTimeout(() => updateCurrentFlag(true), 50);
    });
  }

  const niceSelect = document.querySelector(".nice-select");
  if (niceSelect) {
    niceSelect.addEventListener("click", () => {
      setTimeout(addFlagsToOptions, 50);
      setTimeout(() => updateCurrentFlag(true), 50);
    });
  }

  const currencySelect = document.getElementById("currencies");
  if (currencySelect) {
    currencySelect.addEventListener("change", () => {
      setTimeout(() => updateCurrentFlag(true), 50);
    });
  }

  document.querySelectorAll(".option").forEach((option) => {
    option.addEventListener("click", () => {
      setTimeout(() => updateCurrentFlag(true), 50);
    });
  });
}

function observeMenuDrawer() {
  const menuDrawer = document.querySelector(".menu-drawer__menu");
  if (menuDrawer) {
    const drawerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (
              node.nodeType === Node.ELEMENT_NODE &&
              node.matches(".pick_currency.mldcustom")
            ) {
              node.remove();
            }
          });
        }
      });
    });
    drawerObserver.observe(menuDrawer, { childList: true, subtree: true });
  }
}

// Initialization
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    initializeCurrencyFlags();
    setupObservers();
    setupEventListeners();
    observeMenuDrawer();
    removeDefaultMobileCurrencySwitcher();
    initializeMove();
  }, 1000);
});